import _ from 'lodash';
import React from 'react';

import signedTrueIcon from './assets/signedTrue.svg';
import signedFalseIcon from './assets/signedFalse.svg';

import './styles.css';

const getSignatureStatusIcon = status => {
  if (status === true) return <img src={signedTrueIcon} alt="Signed icon" />;

  if (status === false) return <img src={signedFalseIcon} alt="Signed icon" />;

  return <div className="signedNA">N / A</div>;
};

const getStatusBox = ({role, name, signatureStatus}) => (
  <div className="box">
    <div className="title">{role}</div>
    <div className="name">
      {!_.isNil(name) && name}
      {_.isNil(name) && '-'}
    </div>
    <div className="signatureStatus">
      {getSignatureStatusIcon(signatureStatus)}
    </div>
  </div>
);

const SignaturesInformation = ({
  primaryTenant,
  secondaryTenant,
  guarantor,
  agent
}) => (
  <div className="SignaturesInformation">
    <div className="heading">Details</div>
    <div className="content">
      {getStatusBox({
        role: 'Primary',
        name: primaryTenant.fullName,
        signatureStatus: primaryTenant.signatureStatus
      })}
      {getStatusBox({
        role: 'Secondary',
        name: secondaryTenant.fullName,
        signatureStatus: secondaryTenant.signatureStatus
      })}
      {getStatusBox({
        role: 'Guarantor',
        name: guarantor.fullName,
        signatureStatus: guarantor.signatureStatus
      })}
      {getStatusBox({
        role: 'Agent',
        name: agent.fullName,
        signatureStatus: agent.signatureStatus
      })}
    </div>
  </div>
);

export default SignaturesInformation;
